"use client"

import { ProductWithListing } from "./types"
import { BuyListingForm } from "./BuyListingForm"
import { TokenSales } from "./TokenSales"

interface ListingViewProps {
  product: ProductWithListing
}

export const ListingView: React.FC<ListingViewProps> = ({
  product,
}) => {
  const getNFTName = () => {
    if ("texture" in product) {
      // It's a CLockProduct
      return product.metadata.name || `cLock #${product.tokenId}`
    }
    // It's an LlPhyProduct
    return product.metadata.name || `Phygital #${product.tokenId}`
  }


  const getProductDetails = () => {
    const details: Array<{ label: string; value: string }> = [
      { label: "Token ID", value: product.tokenId.toString() },
      { label: "Chain ID", value: product.chainId.toString() },
      { label: "Contract", value: `${(product as any).contractAddress?.slice(0, 6)}...${(product as any).contractAddress?.slice(-4)}` },
    ]

    if ("texture" in product) {
      // CLockProduct specific details
      details.push(
        { label: "Texture", value: (product as any).texture || "N/A" },
        { label: "Rarity", value: (product as any).rarity || "N/A" },
        { label: "Style", value: (product as any).style || "N/A" }
      )
    } else {
      // LlPhyProduct specific details
      details.push(
        { label: "Category", value: (product as any).category || "N/A" },
        { label: "Series", value: (product as any).series || "N/A" },
        { label: "3D Model", value: (product as any).is3DModel ? "Yes" : "No" }
      )
    }

    return details
  }

  const activeListing =
    product.listings
      .filter((listing) => listing.status === "ACTIVE")
      .sort((a, b) => Number(a.pricePerToken) - Number(b.pricePerToken))[0] ||
    null

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl font-bold mb-3">{getNFTName()}</h3>
        <div className="grid grid-cols-2 gap-3">
          {getProductDetails().map((detail) => (
            <div key={detail.label} className="flex justify-between">
              <span className="text-brand-blue-400">{detail.label}:</span>
              <span className="font-medium">{detail.value}</span>
            </div>
          ))}
        </div>
      </div>

      {activeListing ? (
        <div>
          <h3 className="text-lg font-semibold mb-3">Buy Listing</h3>
          {activeListing ? (
            <BuyListingForm
              listing={activeListing}
              onPurchaseComplete={() => {}}
              onCancel={() => {}}
            />
          ) : (
            <div>No active listings available</div>
          )}
        </div>
      ) : (
        <div className="text-center py-4">
          <div className="text-gray-500">No active listings available</div>
        </div>
      )}

      <div>
        {activeListing && (
          <TokenSales
            listingIds={product.listings.map((l) => Number(l.listingId))}
          />
        )}
      </div>
    </div>
  )
}
